import React , {useEffect} from 'react';
import Navbar from '../component/Navbar';
import Hero from '../component/Hero';
import Fotter from '../component/Fotter';
import image2 from '../assets/photo2.jpg';
import image3 from '../assets/photo3.jpg';
import {AiOutlineInstagram } from "react-icons/ai";
import {FaTwitter} from "react-icons/fa";
const About = () => {
  useEffect(() => {
    document.title = 'AN-TECH - ABOUT'; // Change the title as desired
    // Make sure to replace 'Your Website Name' with your actual website name
  }, []);
  return (
    <>
      <Navbar />
      <Hero
        backgroundImage={image2}
        headingText="ABOUT AN-TECH"
        paraText="About Us: Learn who we are and what we stand for"
      />
<section class="text-gray-400 bg-gray-900 body-font">
  <div class="container mx-auto flex px-5 py-10 md:flex-row flex-col items-center">
    <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 md:mb-0 mb-10">
      <img class="object-cover object-center rounded" alt="hero" src={image3}/>
    </div>
    <div class="lg:flex-grow md:w-1/2 lg:pl-24 md:pl-16 flex flex-col md:items-start md:text-left items-center text-center">
      <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">Welcome to AN-TECH:


        <br class="hidden lg:inline-block"/> Where Creativity Meets Innovation!
      </h1>
      <p class="mb-8 leading-relaxed">At AN-TECH, we're your one-stop destination for all things creative. Whether you need stunning graphic designs, user-friendly websites, or captivating video content, we've got you covered. Our talented team specializes in turning your ideas into visually compelling and engaging digital experiences. With AN-TECH, creativity knows no bounds, and innovation is our driving force. Let's collaborate and bring your digital dreams to life!</p>
      <p className='text-bold text-medium'>AN-TECH is more than just an agency; it's a beacon of creativity, a hub of innovation, and a trusted partner on your digital journey. Join us as we redefine the way you connect with your audience, one creative project at a time.</p>
      <div class="flex justify-center">
      </div>
    </div>
  </div>
</section>
<section className="text-white bg-gray-900 body-font">
  <div className="container px-5 py-7 mx-auto">
    <h1 className="text-3xl font-medium title-font text-white mb-12 text-center">Testimonials</h1>
    <div className="flex flex-wrap -m-4">
      <div className="p-4 md:w-1/2 w-full">
        <div className="h-full bg-gray-800 bg-opacity-40 p-8 rounded">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            className="block w-5 h-5 text-gray-500 mb-4"
            viewBox="0 0 975.036 975.036"
          >
            <path
              d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"
            ></path>
          </svg>
          <p className="leading-relaxed mb-6">Anup Ghose is not your typical designer and video editor; he's a virtuoso who weaves visual magic and storytelling brilliance into every project. His journey in the world of design and editing is a testament to his passion.</p>
          <a className="inline-flex items-center">
           
            <span className="flex-grow flex flex-col pl-4">
              <span className="title-font font-medium text-white">Anup Ghose</span>
              <span className="text-gray-500 text-sm">CO-FOUNDER</span>
            </span>
          </a>
        </div>
      </div>
      <div className="p-4 md:w-1/2 w-full">
        <div className="h-full bg-gray-800 bg-opacity-40 p-8 rounded">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            className="block w-5 h-5 text-gray-500 mb-4"
            viewBox="0 0 975.036 975.036"
          >
            <path
              d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"
            ></path>
          </svg>
          <p className="leading-relaxed mb-6">Nabil Khan is not your average developer; he's a code maestro who's pushing the boundaries of technology. With an insatiable curiosity and a knack for problem-solving, Nabil has made a name for himself in the world of software development.</p>
          <a className="inline-flex items-center">
       
            <span className="flex-grow flex flex-col pl-4">
              <span className="title-font font-medium text-white">Nabil Khan</span>
              <span className="text-gray-500 text-sm">CO-FOUNDER</span>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

      <Fotter />
    </>
  );
};

export default About;
